import React, { useEffect, useState } from "react";
import { api } from "../../util/api";
import { Box, Typography } from "@mui/material";
import CalendarView from "./component/CalendarView";
import MySchedulePage from "./MySchedulePage";
import DetailModal from "../../component/common/DetailModal";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function CalendarPage() {
    const [view, setView] = useState("month"); // month | week | day
    const [myOpen, setMyOpen] = useState(false);
    const [me, setMe] = useState(null);

    useEffect(() => {
        api.get(`${API_BASE}/employees/me`).then(d => setMe(d)).catch(() => {});
    }, []);

    return (
        <Box sx={{ maxWidth: 1600, mx: "auto", py: 3, px: 1 }}>
            <Box mb={2}>
                <Typography sx={{ fontSize: 20, fontWeight: 800, letterSpacing: "-0.3px", color: "text.primary" }}>
                    직원 캘린더
                </Typography>
                <Typography sx={{ mt: 0.4, fontSize: 13, color: "text.secondary" }}>
                    직원·팀별 일정을 월간·주간·일간으로 관리합니다
                </Typography>
            </Box>

            <CalendarView view={view} setView={setView} me={me} onMyClick={() => setMyOpen(true)} />

            {/* 내 일정 모달 */}
            <DetailModal
                open={myOpen}
                onClose={() => setMyOpen(false)}
                title="내 일정"
                subtitle="내가 등록한 일정을 기간별로 조회하고 수정합니다"
                maxWidth="md"
            >
                <MySchedulePage me={me} />
            </DetailModal>
        </Box>
    );
}
